import { motion } from "framer-motion";
import { ClipboardCheck, Rocket, CalendarClock } from "lucide-react";
import { useLang } from "@/lib/i18n";

const ICONS = [ClipboardCheck, Rocket, CalendarClock];

export default function Engagement() {
  const { t } = useLang();
  const items = t("engage.items");
  return (
    <section id="engagement" data-testid="engagement-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <p className="font-mono text-xs tracking-[0.25em] uppercase text-primary mb-4">{t("engage.overline")}</p>
        <h2 className="font-heading font-bold tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl mb-14">
          {t("engage.h1")}<span className="text-accent">.</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          {items.map((item, i) => (
            <motion.article
              key={item.title}
              data-testid={`engage-card-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="border border-black bg-white p-7 hover:border-accent transition-colors duration-300"
            >
              {(() => { const Icon = ICONS[i]; return <Icon className="w-5 h-5 text-primary mb-6" strokeWidth={1.75} />; })()}
              <div className="flex items-center justify-between gap-3 mb-3">
                <h3 className="font-heading font-bold text-xl tracking-tight">{item.title}</h3>
                <span className="font-mono text-[10px] tracking-widest uppercase px-2.5 py-1 bg-accent/10 text-accent border border-accent/30 whitespace-nowrap">{item.meta}</span>
              </div>
              <p className="text-muted-foreground text-sm leading-relaxed">{item.desc}</p>
            </motion.article>
          ))}
        </div>
        <p className="font-mono text-xs tracking-[0.15em] uppercase text-muted-foreground" data-testid="engage-note">{t("engage.note")}</p>
      </div>
    </section>
  );
}
